import styled from 'styled-components'
import Image from 'next/legacy/image'
import { MdClose } from 'react-icons/md'
import Link from 'next/link'
import ContentRenderer from 'content-renderer'
import Wrapper from 'common/wrapper'
import AnimatedModal from 'common/animations/animated-modal'
import { Typography } from 'common/typography'
import { useCourse } from 'querys/course'
import { SecondaryButton, TransparentButton } from 'common/button'
import { useSubscriptionStatus } from 'querys/subscriptions'
import { customScrollBar } from 'common/scroll-bar'

const CourseProjectModalStyled = styled.div`
  overflow-y: auto;
  height: 100vh;
  align-items: center;
  display: flex;
  .project-modal-container {
    flex: 1;
    padding: 24px;
    max-height: 80%;
    background: var(--basePrimary);
    ${customScrollBar}
    overflow: auto;
  }
  .close-container {
    position: sticky;
    z-index: 10;
    top: 24px;
    right: 24px;
    display: flex;
    justify-content: flex-end;
  }
  .title-container {
    margin-bottom: 16px;
  }
  .content-container {
    font: var(--regular);
    ul {
      padding-inline-start: 1rem;
    }
    li {
      margin-block: .5rem;
      position: relative;
      &::before {
        position: absolute;
        content: '';
        left: -1rem;
        top: 6px;
        display: block;
        width: .5rem;
        height: .5rem;
        background: var(--turquoise);
        border-radius: 50%;
      }
    }
  }
  .img {
    max-width: 100%;
    height: auto;
    &:nth-of-type(2) {
      margin: 24px 0;
    }
  }
  .cta {
    margin-top: 24px;
  }
  @media (min-width: 768px) {
    .cta {
      margin-top: 64px;
    }
    .img {
      &:nth-of-type(2) {
        margin: 64px 0;
      }
    }
  }
`

function CourseProjectModal({ showProject, setShowProject }) {
  const { data: { project } } = useCourse()
  const { data: { is_active } } = useSubscriptionStatus({ product: 'ALL' })
  const {
    title, description: { blocks }, cover_image, detail_image, slug,
  } = project

  return (
    <AnimatedModal show={showProject}>
      <Wrapper maxWidth="792">
        <CourseProjectModalStyled>
          <div className="project-modal-container">
            <div className="close-container">
              <TransparentButton color="var(--secondary)" onClick={() => setShowProject(false)}>
                <MdClose size="24" />
              </TransparentButton>
            </div>
            <div className="title-container">
              <Typography as="h1" small="headline4" large="headline3" color="var(--baseNeutral)">
                {title}
              </Typography>
            </div>
            <div className="content-container">
              <ContentRenderer chunks={blocks} />
            </div>
            <Image className="img" width="744" height="560" src={cover_image} alt="Vista del proyecto completado" />
            <Image className="img" width="744" height="550" src={detail_image} alt="Proyeccion del proyecto con componentes sobresalientes" />
            <div className="cta">
              <Link href={`/proyectos/${slug}`} passHref>
                <SecondaryButton fullWidth>
                  Ver proyecto
                </SecondaryButton>
              </Link>
            </div>
          </div>
        </CourseProjectModalStyled>
      </Wrapper>
    </AnimatedModal>
  )
}

export default CourseProjectModal
